// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"2a303ef6","733":"c5f4a80c","822":"223a432f"}[chunkId] + ".chunk.js";
};